export default {"src":"/_next/static/media/Check.0d990104.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};